/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PageDataUserWalletListRespVo } from './PageDataUserWalletListRespVo';
import {
    PageDataUserWalletListRespVoFromJSON,
    PageDataUserWalletListRespVoFromJSONTyped,
    PageDataUserWalletListRespVoToJSON,
    PageDataUserWalletListRespVoToJSONTyped,
} from './PageDataUserWalletListRespVo';

/**
 * 
 * @export
 * @interface ResponsePageDataUserWalletListRespVo
 */
export interface ResponsePageDataUserWalletListRespVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponsePageDataUserWalletListRespVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponsePageDataUserWalletListRespVo
     */
    message?: string;
    /**
     * 
     * @type {PageDataUserWalletListRespVo}
     * @memberof ResponsePageDataUserWalletListRespVo
     */
    data?: PageDataUserWalletListRespVo;
}

/**
 * Check if a given object implements the ResponsePageDataUserWalletListRespVo interface.
 */
export function instanceOfResponsePageDataUserWalletListRespVo(value: object): value is ResponsePageDataUserWalletListRespVo {
    return true;
}

export function ResponsePageDataUserWalletListRespVoFromJSON(json: any): ResponsePageDataUserWalletListRespVo {
    return ResponsePageDataUserWalletListRespVoFromJSONTyped(json, false);
}

export function ResponsePageDataUserWalletListRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponsePageDataUserWalletListRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : PageDataUserWalletListRespVoFromJSON(json['data']),
    };
}

export function ResponsePageDataUserWalletListRespVoToJSON(json: any): ResponsePageDataUserWalletListRespVo {
    return ResponsePageDataUserWalletListRespVoToJSONTyped(json, false);
}

export function ResponsePageDataUserWalletListRespVoToJSONTyped(value?: ResponsePageDataUserWalletListRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': PageDataUserWalletListRespVoToJSON(value['data']),
    };
}

